import { render, staticRenderFns } from "./file_out_extra_info.vue?vue&type=template&id=38562a18&"
import script from "./file_out_extra_info.vue?vue&type=script&lang=js&"
export * from "./file_out_extra_info.vue?vue&type=script&lang=js&"
import style0 from "./file_out_extra_info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports